import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { dsDtos } from '@vectronic/openApi-admin';
import { ParameterDialogComponent } from '@vectronic/ui';
import { DialogService } from '@vectronic/util';

@Component({
  selector: 'table-datatable-parameter',
  templateUrl: './datatable-parameter.component.html',
  styleUrls: ['./datatable-parameter.component.scss'],
  imports: [MatButtonModule, CommonModule],
})
export class DatatableParameterComponent {
  parameterDataList = input<dsDtos.ParameterData[]>();
  idDevice = input<number>();
  deviceClassId = input<string>();
  parameters = input<dsDtos.Parameter[]>();
  categories = input<dsDtos.ParameterCategory[]>();
  subsystems = input<dsDtos.Subsystem[]>();
  deviceClasses = input<dsDtos.DeviceClass[]>();
  isCompactMode = input(false);
  deviceTypeParameterConfig = input<dsDtos.DeviceTypeParameterConfigWithAvailableList[]>();

  private dialogService = inject(DialogService);

  onClickParameter() {
    const deviceClass = this.deviceClasses()?.find(({ id }) => id === this.deviceClassId());
    this.dialogService.openWide(ParameterDialogComponent, {
      data: {
        parameterDataList: this.parameterDataList(),
        parameters: this.parameters(),
        categories: this.categories(),
        subsystems: this.subsystems(),
        idDevice: this.idDevice(),
        deviceName: deviceClass?.name,
        deviceTypeParameterConfig: this.deviceTypeParameterConfig(),
      },
    });
  }
}
